export const business = {
  legalName: "BMTAX INDIA (OPC) PRIVATE LIMITED",
  brandName: "BMTAX",
  tagline: "Simplifying Tax, Empowering Growth",
  phone: "+91 70026 95990",
  phoneHref: "tel:+917002695990",
  email: "bmtaxopc@gmail.com",
  supportEmail: "bmprofca@gmail.com",
  address: {
    line1: "Kharupetia",
    line2: "Darrang, Assam 784115",
    full: "Kharupetia, Darrang, Assam 784115, India"
  },
  mapEmbed: "https://www.google.com/maps?q=Kharupetia,Assam,India&output=embed",
  cin: "U70200AS2025OPC027638",
  pan: "AANCB2545D",
  loginUrl: "https://bmtaxopc.com/login.html",
  poweredBy: "OneSaas Technologies Private Limited"
};
